<template>
  <div class="main-wrapper">
    <ClientOnly>
      <AlertUpdateMessage />
      <UpdateMessage />
    </ClientOnly>
    <div
      class="flex wrapper"
      :style="{
        height: `calc(100% - ${topHeight}px)`,
      }"
    >
      <div
        v-if="userId"
        class="sider"
        :class="getEnv('area') === 'CN' ? 'w-[240px]' : 'w-[258px]'"
      >
        <div class="relative h-full">
          <XSider />
        </div>
      </div>
      <div
        :key="userId"
        class="content"
        :style="{
          backgroundImage: `url(${transformImage(
            getFeUrl(
              `/youyan-platform/png/${
                getEnv('area') === 'CN' ? 'white' : 'black2'
              }.png`
            )
          )})`,
        }"
        @scroll="scrolling"
      >
        <ClientOnly v-if="userId">
          <AlertMessages />
          <NotificationMessages />
        </ClientOnly>
        <ClientOnly>
          <Compatibility />
        </ClientOnly>
        <slot></slot>
      </div>
    </div>
    <div ref="topRef">
      <Top></Top>
    </div>
  </div>
  <Account />
  <VideoDownload />
  <ClientOnly>
    <TemplateModal />
  </ClientOnly>
  <PublishProcess />
  <TasteAccountHint v-model:open="showCreateModal" :accounts="accountList" />
  <FloatComps v-if="!isMobile" />
</template>

<script lang="ts" setup>
import { AlertMessages, NotificationMessages } from '@youyan/common'
import Top from '../components/xTop/index.vue'
import { AlertUpdateMessage } from '@/features/alert/topAlertUpdateMessage'
import { useDetector } from '~/hooks/useDetector'
import { PageKey } from '~/constants/page'
import Compatibility from '~/components/compatibility/index.vue'

import Account from '@/features/account/index.vue'
import VideoDownload from '@/features/videoDownload/index.vue'
import PublishProcess from '@/features/publish/index.vue'
import TemplateModal from '~/features/template/components/modal.vue'
import TasteAccountHint from '~/features/tasteAccountHint/index.vue'
import FloatComps from '@/features/floatComps/index.vue'

const route = useRoute()
const router = useRouter()
const userInfo = useUserInfo()
const shareVisible = useShare()
const { isHome } = useDetector()
const { isMobile } = useDevice()
const showCreateModal = useCheckCreate()
const accountList = useAccountList()
const topRef = ref()

const topHeight = ref(0)

useResizeObserver(topRef, (entries) => {
  const entry = entries[0]
  const { height } = entry.contentRect
  topHeight.value = height + 56
})

const routeType = computed(() => route.fullPath.split('/')[1])

const userId = computed(() => userInfo.value?.user_id)

const isRightPage = computed(() => route.name === PageKey.CENTER_EQUITY)

const checkDataPermission = () => {
  const routeList = router.getRoutes()
  const currentRoute = route.name
  const targetRouter = routeList.find((item: any) => item.name === currentRoute)
  const result = checkRoutePermission(targetRouter)

  if (!result) {
    router.push({
      name: PageKey.CENTER_ACCOUNT,
    })
  }
}

const scrolling = () => {
  if (!shareVisible.value) {
    return
  }

  shareVisible.value = false
}
// 个人中心页面退出登录跳转到首页精选
watch(
  () => userInfo.value?.user_id,
  (current, before) => {
    if (routeType.value === 'center') {
      if (current) {
        checkDataPermission()
      } else {
        goHome()
      }
      return
    }

    // home内容若用户退出登录需定位到首页
    if (current !== before && !current && isHome.value) {
      setTimeout(() => {
        goHome()
      }, 0)
    }
  },
  {
    immediate: true,
  }
)
</script>

<style lang="scss" scoped>
.wrapper {
  @apply bg-back-bg absolute w-full;

  .sider {
    background-color: var(--menu-bg);
    flex-shrink: 0;
  }

  .content {
    @apply flex-1 flex flex-col;
    height: 100%;
    border-left: 1px solid var(--back-2);
    background: var(--back-bg);
    :deep(> :last-child) {
      @apply flex flex-col;
      flex: 1;
      overflow: auto;
    }
  }
}
</style>
